module.exports = __webpack_public_path__ + "static/logo_footer-a9793cebfb81eb9fbc69d36f177e817c.svg";